<app-toolbar-search></app-toolbar-search>
<div class="redirecting-container">
  <mat-spinner [diameter]="50" color="accent"></mat-spinner>
  <p class="redirecting-text">
    {{ "RedirectingToClientPortal" | translate }}
  </p>
</div>
